import { Component, Input } from '@angular/core';
import { HandsetService } from '../../../core/services/handset.service';
import { LOGO_CDN_URL, LOGO_SUFFIX } from '../../configs/biller-logo-config';

@Component({
standalone: false,
  selector: 'app-notifications-biller-logo',
  styleUrls: ['./notifications-biller-logo.component.scss'],
  templateUrl: './notifications-biller-logo.component.html',
})
export class NotificationsBillerLogoComponent {
  @Input() billerCodes: string[];

  public logoCdnUrl = LOGO_CDN_URL;
  public logoSuffix = LOGO_SUFFIX;

  constructor(public handsetService: HandsetService) {}
}
